function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    xmlSpace: "preserve",
    width: "auto",
    height: "auto",
    viewBox: "0 0 718.21332 283.46667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,283.46667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1525.97,286.352 230,76.187 13.11,109.902 -214.74,-62.82 -28.37,-123.269",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1295.77,516.809 210.12,51.429 25.96,112.434 -195.99,-41.012 -40.09,-122.851",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1183.64,172.949 250.25,82.891 29.29,127.109 -233.34,-68.25 -46.2,-141.75",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1242.91,354.641 229.23,67.07 25.04,108.629 -214.08,-52.379 -40.19,-123.32",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 834.16,57.1602 c -0.012,0 -0.027,0.0117 -0.039,0.0117 l 251.939,83.4491 47.55,145.918 -527.184,-154.23 C 680.078,98.1602 756.477,73.1211 834.16,57.1602",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1980.7,1547.65 c 0.01,-0.02 0.01,-0.03 0.01,-0.05 l -90.26,-756.51 168.64,35.23 c 60.58,241.9 32.58,498.6 -78.39,721.33",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1140.37,40.2305 c -0.05,0 -0.1,-0.0313 -0.14,-0.0313 87.5,8.0117 173.87,26.961 257.01,56.6016 0,0.0078 -0.01,0.0195 -0.01,0.0195 l 27.51,119.4997 -254.43,-84.281 -29.94,-91.8085",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1563.32,448.359 210.21,61.5 10.83,90.731 -197.07,-48.18 -23.97,-104.051",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1800.62,736.852 -179.45,-37.543 -25.18,-109.008 192.78,47.148 11.85,99.403",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 363.523,288.73 837.627,204.93 41.29,126.488 -999.71,-208.949 c -0.003,-0.008 -0.011,-0.008 -0.019,-0.019 36.355,-43.469 76.625,-84.532 120.894,-122.539 -0.031,0.019 -0.05,0.078 -0.082,0.089",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 218.164,441.551 1254.82,658.238 1666.55,1920.99 C 1212.85,2256.57 571.793,2171.96 222.051,1724.75 -78.9063,1340.09 -67.7305,810.68 218.219,441.441 c -0.028,0.028 -0.035,0.071 -0.055,0.11",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1072.68,99.6914 907.188,44.8789 c 0,-0.0078 -0.004,-0.0078 -0.004,-0.0195 48.097,-6.3711 96.446,-9.3086 144.726,-8.9805 l 20.77,63.8125",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1146.67,326.512 1188.5,454.828 396.992,261.16 v -0.019 c 1.5,-1.18 2.895,-2.442 4.403,-3.621 50.71,-39.668 104.05,-73.598 159.101,-102.508 l 586.174,171.5",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1926.24,518.41 -70.79,-20.691 -10.71,-89.86 c -0.03,-0.019 -0.06,-0.07 -0.09,-0.109 8.08,9.621 16.21,19.191 24.02,29.16 20.71,26.488 39.81,53.719 57.58,81.488 -0.01,0 -0.01,0.012 -0.01,0.012",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1751.43,324.531 -234.61,-77.722 -25.68,-111.278 c -0.01,-0.011 -0.04,-0.019 -0.06,-0.043 92.88,43.703 180.16,101.532 258.48,173.114 l 1.87,15.929",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1348.24,677.77 192.17,40.152 252.14,1093.498 0.01,-0.01 c -18.23,18.61 -37.14,36.75 -57,54.18 L 1348.24,677.77",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1952.73,562.121 c 17.07,29.789 32.5,60.18 46.37,91.027 l -128.86,-31.527 -10.33,-86.473 92.9,27.192 c -0.04,-0.07 -0.05,-0.16 -0.08,-0.219",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1911.51,1665.97 c -16.07,23.78 -33.28,46.93 -51.46,69.51 0,0 0.01,-0.01 0.01,-0.03 l -230.31,-998.848 175.19,36.636 106.54,892.752 c 0.01,-0.01 0.02,-0.02 0.03,-0.02",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2048.88,788.73 -162.75,-34.05 -11.52,-96.211 141.29,34.543 c 0.02,-0.012 0.02,-0.024 0.02,-0.032 12.62,31.532 23.61,63.481 33,95.75 -0.02,0 -0.03,0 -0.04,0",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 754.16,1670.43 c 64.313,138.49 300.81,226.4 361.98,209.38 7.33,-35.19 -253.718,-183.34 -361.98,-209.38 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 732.074,1850.56 c 35.196,-89.54 -164.222,-294.71 -231.527,-340.06 28.894,176.93 226.625,352.25 231.527,340.06",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 774.137,1522.64 c -196.754,-4.73 -357.653,-169.68 -347.981,-185.94 71.227,5.28 218.157,66.21 347.981,185.94 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 307.41,1108.32 c -26.297,-0.06 -46.683,305.56 116.766,489.17 25.226,-170.54 -82.891,-322.52 -116.766,-489.17 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 343.762,1068.81 c 12.426,172.37 221.203,250.63 245.57,235.07 6.918,-13.35 -45.152,-77.71 -72.18,-99.88 -36.207,-29.5 -166.718,-152.6 -173.39,-135.19",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 522.301,655.07 c 27.461,-34.789 -351.895,167.77 -324.125,249.078 5.265,5.024 179.082,-64.589 324.125,-249.078",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 658.008,1588.4 c 138.371,-39.02 212.375,-25.75 363.502,11.23 -155.127,40.1 -231.569,48.9 -363.502,-11.23 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 395.824,835.039 C 365.234,957.148 181.414,1208.9 120.738,1171.15 106,1161.12 270.875,947.469 395.824,835.039 v 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1788.77,637.449 -192.78,-47.148 25.18,109.008 179.45,37.543 z m -15.24,-127.59 -210.21,-61.5 23.97,104.051 197.07,48.18 z m -17.56,-147.32 -230,-76.187 28.37,123.269 214.74,62.82 z m -250.08,205.699 -210.12,-51.429 40.09,122.851 195.99,41.012 z m -33.75,-146.527 -229.23,-67.07 40.19,123.32 214.08,52.379 z m -38.25,-165.871 -250.25,-82.891 46.2,141.75 233.34,68.25 z m 614.99,532.89 c 3.65,12.481 7.04,25.02 10.23,37.602 l -168.66,-35.242 90.26,756.51 c -20.29,40.74 -43.44,80.25 -69.23,118.39 l -106.54,-892.752 -175.19,-36.636 230.31,998.848 c -21.12,26.24 -43.62,51.57 -67.51,75.97 L 1540.41,717.922 1348.24,677.77 1735.56,1865.59 c -14.95,13.16 -30.32,26.05 -46.2,38.48 -7.52,5.87 -15.21,11.31 -22.81,16.92 L 1254.82,658.238 218.164,441.551 c 7.91,-10.289 16.176,-20.352 24.566,-30.352 L 1242.44,620.148 1201.15,493.66 363.523,288.73 c 10.915,-9.39 22.067,-18.582 33.469,-27.57 L 1188.5,454.828 1146.67,326.512 560.465,155 c 15.18,-7.949 30.519,-15.488 45.957,-22.691 L 1133.61,286.539 1086.06,140.621 834.121,57.1719 c 24.219,-5.0117 48.629,-9.0703 73.067,-12.293 l 165.492,54.8125 -20.77,-63.8125 c 29.54,0.2031 59.06,1.6719 88.46,4.3516 l 29.94,91.8085 254.43,84.281 -27.51,-119.4997 c 31.82,11.3277 63.17,24.2387 93.91,38.7107 l 25.68,111.278 234.61,77.722 -1.87,-15.941 c 33.47,30.601 65.23,63.699 95.18,99.269 l 10.71,89.86 70.79,20.691 c 9.25,14.481 18.11,29.141 26.57,43.93 l -92.9,-27.192 10.33,86.473 128.87,31.527 c 5.89,13.211 11.46,26.512 16.79,39.864 l -141.29,-34.543 11.52,96.211 162.75,34.05",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2618.75,227.559 c -13.19,0 -44.34,-50.539 -48.39,-59.707 -5.82,-14.653 -10.24,-30.063 -10.24,-45.793 0,-20.918 9.13,-40.309 23.46,-56.8285 2.56,-0.7188 5.1,-1.0703 7.33,-1.0703 27.84,0 46.17,58.9808 46.17,85.3398 0,12.141 -4.05,78.059 -18.33,78.059 z m 128.28,85.371 c -1.5,-0.34 -2.95,-0.68 -4.05,-0.68 h -2.95 c -8.4,0 -14.62,5.5 -21.57,5.5 -13.19,0 -59.39,-40.691 -71.12,-58.648 5.86,-35.223 24.59,-67.821 24.59,-104.454 0,-55.6871 -15.45,-86.1089 -60.51,-120.1792 -6.24,-1.4805 -11.73,-2.1875 -16.85,-2.1875 -46.9,0 -61.94,61.1601 -61.94,95.2497 0,34.809 6.94,56.778 19.78,75.489 12.82,19.429 30.04,33.359 50.59,55.71 0.4,1.821 0.7,3.29 0.7,4.02 0,8.461 -7.32,13.559 -20.12,22.012 -12.11,7.687 -24.96,16.09 -33.7,33.718 6.19,6.219 10.96,9.508 17.2,9.508 23.13,0 50.21,-37.398 60.11,-37.398 5.5,0 15.76,8.789 19.4,12.48 l 14.32,12.121 c 21.97,16.481 46.18,31.469 72.52,44.321 12.1,0.347 25.32,-5.153 25.32,-19.43 0,-9.922 -2.95,-19.422 -11.72,-27.152",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2796.9,172.629 c -22.35,0 -35.14,13.543 -35.14,35.543 0,24.906 9.5,43.226 19.42,57.508 4.77,6.98 9.49,12.82 12.78,17.23 1.5,1.852 5.55,6.231 5.55,8.82 0,6.571 -9.17,16.11 -13.2,21.2 l -0.36,5.14 c -1.88,25.301 29.99,46.571 51.99,46.571 7.35,0 13.94,-3.321 20.19,-10.282 0.37,-7.3 0.73,-15.359 -8.03,-18.679 -3.33,0.742 -6.25,1.84 -9.24,3.32 -2.92,1.082 -5.08,1.82 -6.54,1.82 -7.71,0 -23.12,-14.691 -23.12,-22.34 0,-12.48 29.36,-13.941 29.36,-31.179 0,-1.801 -0.39,-4.02 -1.49,-6.582 -24.94,-15.778 -45.11,-34.071 -45.11,-61.571 0,-6.976 1.14,-20.539 11.79,-20.539 28.57,0 52.38,30.063 60.43,30.063 5.89,0 12.08,-6.602 12.08,-12.07 0,-20.532 -63,-43.973 -81.36,-43.973",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3020.52,231.98 c 0,4.77 2.88,8.418 2.88,12.821 0,1.449 -2.88,0.719 -4.01,0.719 h -1.44 c -19.45,-20.52 -17.98,-38.489 -56.47,-38.489 -12.46,0 -18.7,-23.41 -19.8,-31.851 C 2935.84,115.809 2912.43,58.6484 2891.88,3.32031 2887.49,0.75 2884.9,0 2881.97,0 c -8.43,0 -13.56,7.35156 -16.11,14.3086 13.57,64.4922 42.49,127.5194 42.49,194.5504 0,18.7 5.55,36.321 10.27,53.532 5.51,17.949 10.26,36.3 10.26,55.359 0,8.379 -2.92,15.738 -2.92,24.18 0,4.359 2.54,16.84 12.43,16.84 20.92,0 22.76,-16.141 22.76,-30.418 0,-14.981 -4.39,-29.661 -4.39,-44.672 0,-7.75 2.15,-15.418 6.95,-22.41 22.33,4.039 33.31,22.41 44.34,39.21 3.99,5.872 7.68,11.77 14.64,20.52 23.44,-14.648 31.91,-89.379 31.91,-107.359 0,-7.692 -3.3,-15.032 -12.49,-19.422 -19.79,7 -21.59,23.441 -21.59,37.761",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3184.74,321.77 c -5.5,0.351 -9.51,2.929 -10.67,10.261 15.06,19.028 23.84,42.11 38.18,62.278 l 10.61,1.851 c 5.85,-2.949 5.85,-6.98 8.4,-12.48 -7.29,-11.692 -12.43,-23.821 -18.67,-34.442 -6.2,-11.347 -14.3,-21.617 -27.85,-27.468 z m -63.42,-104.11 c 0,-7.68 3.68,-11.711 11.37,-11.711 36.26,0 78.41,45.449 78.41,81.731 0,1.461 -4.36,5.14 -7.31,5.14 -23.46,0 -82.47,-50.23 -82.47,-75.16 z m 96.71,-31.851 c -3.25,5.472 -6.18,11.339 -10.25,16.851 -3.28,4.039 -6.92,6.981 -12.43,6.981 -1.42,0 -2.9,-0.379 -4.73,-0.782 -17.61,-16.109 -39.64,-31.5 -64.88,-31.5 -12.09,0 -37.77,8.813 -37.77,23.11 0,49.863 84.67,123.5 133.38,123.5 7.7,0 15.4,-2.199 23.1,-9.93 C 3240.1,287.301 3232,261.27 3232,233.75 c 0,-13.859 7.35,-34.41 19.05,-42.078 l 2.24,-0.391 h 1.78 c 6.95,0 13.21,3.309 20.13,3.309 2.98,0 5.87,-0.77 11.79,-4.031 -1.12,-17.239 -12.84,-30.43 -27.12,-30.43 -23.82,0 -34.09,13.191 -41.84,25.68",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3422.97,299.379 c -8.81,-4 -19.41,-5.84 -30.77,-10.578 -19.41,-8.821 -39.95,-25.68 -39.95,-85.781 0,-7.688 5.86,-14.282 5.86,-22 0,-9.129 -6.23,-15.372 -13.18,-21.258 -14.28,-0.352 -19.74,4.808 -22.67,17.597 -2.62,8.45 -2.62,17.641 -2.62,25.301 0,28.211 11.34,41.762 22.37,65.602 2.56,5.468 4.42,10.976 5.14,15.75 -4.05,4.039 -10.29,4.398 -18.67,5.519 -9.14,1.059 -17.61,1.809 -24.94,7.278 -1.47,2.953 -2.21,5.55 -2.21,7.371 0,8.41 9.21,12.109 15.42,13.191 9.49,-2.18 18.31,-3.332 26.72,-3.332 25.29,0 49.86,8.082 73.25,20.172 h 8.44 c 7.73,0 15.05,-2.539 17.99,-12.813 -2.94,-12.859 -11.03,-17.968 -20.18,-22.019",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3596.73,188.898 c -2.86,-6.347 -2.54,-10.796 -11.81,-10.796 -11.09,0 -16.25,11.109 -16.25,19.73 0,19.129 6.07,37.25 6.07,56.379 0,12.73 -2.56,25.168 -11.18,35.019 -0.62,0.329 -1.58,0.329 -2.49,0.329 -11.81,0 -22.31,-21.668 -27.42,-30.918 -2.86,-6.051 -5.72,-12.082 -9.22,-18.129 -12.72,-25.821 -25.79,-50.961 -40.47,-50.961 -19.13,0 -18.43,24.519 -18.43,37.238 0,39.801 16.51,79.031 13.02,118.813 1.59,3.796 4.14,7.296 8.3,7.296 8.58,0 11.48,-10.789 11.79,-23.238 0.31,-11.14 -1.26,-23.23 -1.26,-28.019 0,-9.25 0.64,-18.75 4.42,-28.02 0.93,-0.312 2.55,-0.312 4.17,-0.312 8.89,0 16.85,12.101 21.02,18.773 10.16,16.25 23.54,43.008 45.54,43.008 2.85,0 6.68,-0.949 11.11,-2.871 13.09,-21.321 15.32,-44.578 15.32,-67.207 0,-25.141 -3.2,-49.653 -2.23,-76.114",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3807.17,207.852 c -6.53,0 -9.46,3 -9.46,9.808 0,24.43 57.82,73.262 80.53,73.262 1.5,0 4.71,-2.512 5.08,-3.242 0,-35.809 -42.01,-79.828 -76.15,-79.828 z m 154.9,-15.68 c -5.3,3.199 -8.62,4.328 -12.73,4.328 -3.71,0 -7.07,-0.859 -10.33,-1.711 -3.19,-0.84 -6.21,-1.598 -9.46,-1.598 h -1.81 l -1.5,0.278 c -10.71,7.269 -17.88,26.66 -17.88,40.281 0,19.66 4.09,39.051 8,57.73 1.5,7.27 3.08,14.77 4.42,22.25 l 0.2,0.981 -0.74,0.68 c -7.11,7.121 -14.85,10.461 -24.41,10.461 -47.78,0 -135.25,-73.723 -135.25,-125.383 0,-15.278 26,-24.989 39.62,-24.989 20.85,0 42.39,10.34 65.79,31.661 l 0.47,0.097 c 1.24,0.262 2.3,0.512 3.01,0.512 4.7,0 7.49,-2.43 11.3,-6.199 1.93,-2.621 3.38,-5.34 4.96,-8.172 1.57,-2.848 3.18,-5.828 5.19,-8.527 7.7,-12.891 18,-26.602 43.07,-26.602 15.32,0 27.8,13.84 28.99,32.18 l 0.06,1.179 -0.97,0.563",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4137.69,312.84 c -22.43,1.082 -37.89,-20.68 -51.87,-48.68 -14.02,-28.019 -24.53,-58.14 -44.44,-82.672 -32.59,5.621 -22.76,39.59 -36.14,59.551 -5.58,26.621 -22.41,31.852 -20.66,65.512 l 10.14,4.871 c 6.01,-3.84 10.17,-9.781 14.07,-16.82 3.83,-7.301 6.65,-15.731 9.83,-24.122 6.61,-16.82 12.91,-30.128 21.69,-30.128 5.92,0 9.78,7.32 14.03,14.699 19.26,36.09 35.68,89.66 86.17,90.699 l 8.7,-7.672 0.36,-5.598 c 1.01,-8.07 -5.96,-14.41 -11.88,-19.64",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4259.96,297.422 c -8.42,-3.832 -18.54,-5.602 -29.39,-10.121 -18.64,-8.43 -38.23,-24.551 -38.23,-81.981 0,-7.371 5.59,-13.648 5.59,-21.039 0,-8.722 -5.9,-14.679 -12.6,-20.312 -13.65,-0.348 -18.89,4.601 -21.7,16.82 -2.47,8.07 -2.47,16.859 -2.47,24.18 0,26.961 10.84,39.91 21.42,62.691 2.38,5.231 4.19,10.512 4.87,15.059 -3.86,3.871 -9.78,4.222 -17.87,5.269 -8.73,1.024 -16.8,1.731 -23.79,6.973 -1.44,2.809 -2.13,5.301 -2.13,7.039 0,8.039 8.75,11.578 14.72,12.609 9.13,-2.089 17.5,-3.187 25.58,-3.187 24.15,0 47.62,7.726 70.03,19.297 h 8.04 c 7.37,0 14.37,-2.438 17.16,-12.258 -2.79,-12.289 -10.5,-17.18 -19.23,-21.039",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4325.49,246.641 c -0.37,-23.442 0,-46.211 -5.93,-68.661 -1.42,-5.921 -7.72,-7.691 -11.95,-7.691 -15.38,0 -19.65,35.371 -19.65,46.231 0,18.55 12.3,104.39 33.32,104.39 2.81,0 5.61,-0.68 12.24,-3.5 -8.03,-26.269 -8.03,-48.328 -8.03,-70.769",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4411.26,176.25 c -21.97,0 -29.34,20.898 -29.34,37.391 0,24.191 21.28,42.531 46.2,51.3 4.05,-6.953 4.8,-10.25 4.8,-14.293 0,-13.898 -22.76,-18.296 -22.76,-34.789 0,-2.589 1.84,-5.14 5.51,-7.687 51.69,1.808 67.41,89.387 67.41,132.25 0,51.687 -24.92,74.398 -78.01,74.398 -16.15,0 -37.78,-4.011 -43.62,-19.769 4.03,-20.91 33.33,-15.403 47.98,-15.403 10.29,0 27.12,-4.769 34.8,-24.929 -5.44,0.402 -9.49,0.761 -11.71,0.761 h -4.76 c -14.32,0 -27.84,-2.199 -42.14,-2.199 -21.26,0 -51.71,10.25 -51.71,38.11 0,42.879 52.07,45.808 79.9,45.808 75.15,0 93.49,-23.847 93.49,-97.117 0,-54.582 -20.18,-163.832 -96.04,-163.832",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4633.44,209.441 c -3.53,0 -8.17,-3.582 -15.18,-8.972 -12.03,-9.258 -28.5,-21.949 -47.1,-21.949 -9.11,0 -10.48,12.281 -10.48,19.582 0,29.789 24.5,48.867 45.87,62.168 l 0.48,0.3 0.26,0.571 c 1.09,2.589 1.65,5.097 1.65,7.507 0,10.204 -7.33,15.231 -13.77,19.661 -4.97,3.39 -9.2,6.332 -9.2,10.89 0,8.153 14.3,22.973 22.16,22.973 1.28,0 3.11,-0.813 5.11,-1.692 l 0.82,-0.378 c 3.31,-1.641 6.45,-2.813 9.88,-3.532 l 0.61,-0.172 0.61,0.301 c 9.81,4.699 9.42,12.571 9.01,20.321 l -0.04,0.601 -0.36,0.481 c -6.01,7.457 -13.5,11.25 -22.21,11.25 -14.13,0 -31.77,-8.422 -42.93,-20.5 -8.42,-9.024 -12.48,-19.09 -11.74,-29.024 l 0.39,-5.769 0.29,-0.43 c 3.54,-5.367 5.37,-10.348 5.37,-14.797 0,-8.23 -8.98,-24.062 -16.72,-35.262 -8.9,-15.121 -17.99,-33.621 -17.99,-56.39 0,-23.602 14.48,-38.828 36.94,-38.828 15.15,0 82.21,22.328 82.21,47.128 0,6.629 -7.3,13.961 -13.94,13.961",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4665.66,460.012 c -0.94,0.648 -1.69,1.226 -2.35,1.75 -2.61,2.027 -4.49,3.34 -10.59,3.597 h -0.42 l -12.78,-5.73 -0.27,-0.41 c -6.06,-8.231 -10.32,-16.5 -14.48,-24.52 -5.15,-9.82 -9.97,-19.109 -17.78,-28.539 l -0.97,-1.16 0.92,-1.219 c 2.15,-2.82 5.17,-4.211 9.31,-4.211 2.48,0 5.17,0.5 7.51,0.961 l 0.59,0.27 c 13.81,8.629 20.95,17.621 27.5,28.488 2.25,4.031 4.1,7.941 6.05,12.133 2.43,5.137 4.94,10.449 8.36,16.039 l 0.96,1.57 -1.56,0.981",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4731.22,233.84 c -12.68,0 -18.08,-10.059 -18.08,-23.539 0,-10.801 17.71,-12.371 25.01,-12.371 8.95,0 14.69,6.55 14.69,15.461 0,13.519 -7.3,20.449 -21.62,20.449 z m 75.67,62.859 c -13.9,-6.527 -28.56,-8.879 -43.63,-13.847 -13.48,-4.293 -23.89,-10.442 -27.02,-22.403 0.78,-2.711 3.13,-4.23 6.99,-5.019 4.62,-1.559 9.61,-1.93 15.41,-3.461 11.95,-3.078 22.39,-10.41 22.39,-34.719 0,-27.801 -17.37,-45.898 -45.11,-45.898 -26.63,0 -55.2,12.707 -55.2,44.769 0,53.59 47.46,96.027 99.54,96.027 8.86,0 16.59,-1.546 28.53,-7.32 l -1.9,-8.129",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4866.32,168.281 c -23.51,0 -37.03,14.239 -37.03,37.399 0,26.23 10.04,45.519 20.47,60.55 4.98,7.34 9.98,13.489 13.45,18.149 1.54,1.922 5.82,6.551 5.82,9.293 0,6.887 -9.65,16.93 -13.93,22.297 l -0.36,5.41 c -1.94,26.633 31.64,49.031 54.81,49.031 7.71,0 14.66,-3.488 21.2,-10.84 0.41,-7.672 0.76,-16.16 -8.47,-19.648 -3.5,0.777 -6.58,1.937 -9.69,3.488 -3.04,1.141 -5.41,1.922 -6.95,1.922 -8.09,0 -24.28,-15.453 -24.28,-23.523 0,-13.129 30.86,-14.68 30.86,-32.821 0,-1.906 -0.36,-4.238 -1.54,-6.929 -26.24,-16.618 -47.47,-35.848 -47.47,-64.809 0,-7.328 1.19,-21.629 12.38,-21.629 30.05,0 55.16,31.649 63.66,31.649 6.18,0 12.74,-6.938 12.74,-12.711 0,-21.61 -66.37,-46.278 -85.67,-46.278",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5019.89,245.789 c -0.39,-25.82 0,-50.891 -6.54,-75.617 -1.56,-6.543 -8.54,-8.492 -13.11,-8.492 -17.01,0 -21.65,38.968 -21.65,50.929 0,20.43 13.55,114.981 36.66,114.981 3.1,0 6.26,-0.762 13.55,-3.86 -8.91,-28.929 -8.91,-53.242 -8.91,-77.941",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5195.81,290.93 c -1.88,0 -3.82,-0.371 -6.49,-0.371 -1.96,0.371 -4.26,0.371 -6.62,0.371 h -4.23 c -23.13,0 -69.82,-15.059 -69.82,-39.34 0,-7.758 6.19,-13.86 18.52,-20.449 32.4,-17 110.75,-28.571 110.75,-77.961 0,-35.469 -45.55,-59.3792 -74.83,-65.5784 l -14.33,5.4101 c -4.23,6.1992 -6.16,11.9573 -6.16,17.0003 0,5.75 1.93,10.379 6.16,17.738 h 13.12 c 20.49,-1.129 41.67,10.391 41.67,33.172 0,7.359 -9.62,9.629 -19.32,12.726 -9.59,3.063 -21.95,5.793 -34.69,8.872 -34.34,8.492 -84.1,22.781 -84.1,67.531 0,13.488 5.81,18.5 13.13,27.379 27.78,35.101 51.67,42.461 96.41,42.461 17.01,0 66.77,-10.84 66.77,-31.289 0,-11.954 -13.47,-26.231 -25.82,-26.231 -11.22,0 -12.75,10.43 -13.89,18.91 -2.74,1.571 -4.27,2.707 -8.5,6.199 l 2.27,3.45",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5354.86,244.801 c -2.35,-5.219 -8.19,-5.762 -15.12,-5.801 -4.75,12.191 -5.99,20.43 -5.54,29.07 0.59,11.93 2.52,25.461 4.75,37.282 6.48,39.238 13.84,78.418 18.74,117.699 0.24,4.937 0.83,7.808 1.28,9.031 1.87,4.438 6.22,8.77 12.39,8.449 7.76,-0.402 15.62,-7.801 15.24,-16.011 -1.69,-33.301 -18.41,-151.989 -31.74,-179.719 z m -14.23,-85.391 c -11.48,0.559 -19.36,16.211 -18.94,24.852 0.6,11.508 11.61,17.148 21.05,16.668 13.09,-0.68 21.4,-8.93 20.7,-22.071 -0.63,-12.73 -11.25,-20.058 -22.81,-19.449",
    style: {
      fill: "#66ccd8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2752.73,1941.8 v -271.94 h -35.35 v 241.69 H 2579.3 v -241.69 h -35.02 v 271.94 h 8.66 199.79",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2871.64,1910.46 v -79.37 h 102.07 v -31.03 h -102.07 v -99.16 h 104.95 v -31.04 h -140.3 v 271.94 h 140.3 v -31.34 h -104.95",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3094.6,1815.55 c 39.01,0 69.29,7.29 69.29,48.02 0,40.38 -28.51,47.98 -70.34,47.98 h -13.71 v -96 z m -14.76,-145.69 h -35.32 v 271.94 h 54.06 c 59.58,0 101.4,-20.55 101.4,-78.23 0,-52.3 -34.64,-78.66 -87.31,-78.66 h -32.83 v -115.05",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3293.75,1669.86 h -34.96 v 271.94 h 34.96 v -271.94",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3509.4,1887.74 v -156.58 c 55.97,2.91 83.34,33.91 83.34,78.65 0,44.37 -27.37,75.37 -83.34,77.93 z m -35.35,-156.58 v 156.58 c -55.9,-2.92 -82.95,-33.56 -82.95,-77.93 0,-44.74 27.05,-75.74 82.95,-78.65 z m 35.35,-61.3 h -35.35 v 28.52 c -81.09,5.39 -119.32,47.22 -119.32,111.43 0,63.85 38.23,105.3 119.32,110.73 v 21.26 h 35.35 v -21.26 c 81.19,-5.06 119.45,-46.88 119.45,-110.73 0,-64.21 -38.26,-106.38 -119.45,-111.43 v -28.52",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3717.81,1910.46 v -79.37 h 102.07 v -31.03 h -102.07 v -99.16 h 104.98 v -31.04 h -140.32 v 271.94 h 140.32 v -31.34 h -104.98",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3941.86,1815.55 c 38.97,0 69.26,7.29 69.26,48.02 0,40.38 -28.44,47.98 -70.3,47.98 h -13.72 v -96 z m -14.76,-145.69 h -35.37 v 271.94 h 54.12 c 59.52,0 101.36,-20.55 101.36,-78.23 0,-52.3 -34.66,-78.66 -87.3,-78.66 h -32.81 v -115.05",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4135.06,1910.46 v -79.37 h 102.05 v -31.03 h -102.05 v -99.16 h 104.91 v -31.04 h -140.28 v 271.94 h 140.28 v -31.34 h -104.91",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4339.19,1669.86 h -35.01 v 271.94 h 35.01 v -271.94",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4452.8,1769.41 h 89.04 l -44.3,104.25 z m 101.74,-29.57 h -114.37 l -29.94,-69.98 h -37.47 l 124.78,282.43 124.78,-282.43 h -38.25 l -29.53,69.98",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2638.77,1377.04 -73.61,-174.56 h 146.09 z m -125.84,-205.58 125.84,282.42 125.88,-282.42 h -11.2 -240.52",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2745.6,1443.4 h 41.79 l 67.85,-115.42 69.2,115.42 h 41.89 l -93.46,-151.47 v -120.47 h -35.29 v 120.47 l -91.98,151.47",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3092.59,1171.46 h -35.71 v 240.61 h -65.27 v 31.33 h 166.6 v -31.33 h -65.62 v -240.61",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3248.74,1171.46 h -34.97 v 271.94 h 34.97 v -271.94",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3487.83,1443.4 h 45.15 c -41.15,-42.88 -82.63,-85.85 -124.12,-128.38 l 131.31,-143.56 h -46.23 l -108.16,119.75 -12.63,-12.98 v -106.77 h -35 v 271.94 h 35 v -121.17 l 114.68,121.17",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3754.6,1331.97 v 111.43 h 35.37 v -271.94 h -35.37 v 130.2 h -140.26 v -130.2 h -35.03 v 271.94 h 35.03 v -111.43 h 140.26",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3920.84,1310.3 -91.94,133.1 h 195.87 v -31.33 h -130.61 l 69.29,-101.77 -74.28,-107.82 h 143.51 v -31.02 h -208.12 l 96.28,138.84",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2579.65,913.59 v -79.34 h 102.03 v -30.98 h -102.03 v -99.219 h 104.95 v -31.02 H 2544.28 V 944.98 h 140.32 v -31.39 h -104.95",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2705.18,673.031 122.93,281.719 124.45,-281.719 h -38.24 l -86.21,204.86 -85.44,-204.86 h -37.49",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2953.43,673.031 122.93,281.719 124.45,-281.719 h -38.24 l -86.21,204.86 -85.44,-204.86 h -37.49",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3292.26,772.559 h 89.08 l -44.35,104.25 z m 101.75,-29.571 h -114.36 l -29.96,-69.957 h -37.48 l 124.78,282.418 124.8,-282.418 h -38.23 l -29.55,69.957",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3590.3,878.609 -73.61,-174.558 h 146.09 z M 3464.46,673.031 3590.3,955.449 3716.18,673.031 h -11.17 -240.55",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3805.06,772.559 h 89.03 l -44.33,104.25 z m 101.71,-29.571 h -114.41 l -29.9,-69.957 h -37.53 l 124.83,282.418 124.8,-282.418 h -38.25 l -29.54,69.957",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4077.89,811.871 -91.94,133.109 h 195.86 v -31.39 h -130.58 l 69.25,-101.719 -74.3,-107.82 h 143.53 v -31.02 h -208.12 l 96.3,138.84",
    style: {
      fill: "#444142",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5bdc2f81429553dc2a2572fea9722554.svg";
export { ForwardRef as ReactComponent };